/* Sweeps the four proof stats in: each rule draws left-to-right and its number
   and label rise in just behind it. The transitions themselves live in
   agency-resources.scss — this only primes the list and stages the reveal, so
   the section still renders complete if the script never runs. */
const LIST_SELECTOR = ".js-agency-resources--proof";
const PRIMED_CLASS = "is-primed";
const REVEALED_CLASS = "is-revealed";
const TRIGGER_START = "top 82%";
/* Close enough to read as one gesture, far enough apart to read as four. */
const ITEM_STAGGER_MS = 90;

class AgencyResourcesProof {
  constructor() {
    this.list = document.querySelector(LIST_SELECTOR);

    if (!this.list) {
      return;
    }

    this.items = Array.prototype.slice.call(this.list.children);

    if (!this.items.length) {
      return;
    }

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    this.timeouts = [];
    this.list.classList.add(PRIMED_CLASS);
    this.init();
  }

  reveal() {
    this.items.forEach((item, index) => {
      this.timeouts.push(
        window.setTimeout(() => {
          item.classList.add(REVEALED_CLASS);
        }, index * ITEM_STAGGER_MS),
      );
    });
  }

  init() {
    if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
      gsap.registerPlugin(ScrollTrigger);
      ScrollTrigger.create({
        trigger: this.list,
        start: TRIGGER_START,
        once: true,
        onEnter: () => this.reveal(),
      });

      return;
    }

    /* Without GSAP the section would otherwise sit primed and invisible. */
    if (!("IntersectionObserver" in window)) {
      this.reveal();

      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }
          observer.disconnect();
          this.reveal();
        });
      },
      { rootMargin: "0px 0px -18% 0px" },
    );

    observer.observe(this.list);
  }
}

document.readyState === "loading"
  ? document.addEventListener(
      "DOMContentLoaded",
      () => new AgencyResourcesProof(),
    )
  : new AgencyResourcesProof();
